import common from '../mixins/common'
export default {
    namespaced: true,

    state: {
        authenticated: false,
        user: null,
        abilities: []
    },

    getters: {
        authenticated (state) {
            return state.authenticated
        },

        user (state) {
            return state.user
        },

        abilities (state) {
            return state.abilities
        }
    },

    mutations: {
        SET_AUTHENTICATED (state, value) {
            state.authenticated = value
        },

        SET_USER (state, value) {
            state.user = value
        },

        SET_ABILITIES (state, value) {
            state.abilities = value
        }
    },

    actions: {
        async signIn ({ dispatch }, credentials) {
            await axios.get('/sanctum/csrf-cookie')
            const result = await axios.post('/login', credentials)
            .then((res) => {
                return dispatch('me')
            }, () => {
                return 'login error'
            })

            return result
        },

        async signOut ({ dispatch, commit }) {
            commit('SET_AUTHENTICATED', false)
            commit('SET_USER', null)
            commit('SET_ABILITIES', [])

            await axios.post('/logout')

            return dispatch('me')
        },

        me ({ commit }) {
            return axios.get('/api/user').then((response) => {
                commit('SET_AUTHENTICATED', true)
                commit('SET_USER', response.data)
            }).catch(() => {
                commit('SET_AUTHENTICATED', false)
                commit('SET_USER', null)
                commit('SET_ABILITIES', [])
            })
        },

        setAbility({commit}, data) {
            commit('SET_ABILITIES', data)
        }
    }
}